import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from './env.service';

export class TareaModel {
  _id?: string;
  estado_caso?: string;
  tareacasoId?: string;
  checked?: boolean;
  unidad: string;
  titulo: string;
  descripcion: string;
  observaciones: string;
  requerido: boolean;
  archivos_adjuntos: [string];
  tabla: boolean;
  creadoPor: string;
  asignadoA: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TareasService {

  constructor(public http: HttpClient, private env: EnvService) { }

  // headers = new HttpHeaders().set('Content-Type', 'application/json');

  post(tarea: TareaModel): Observable<any> {
    return this.http.post(`${this.env.URL_API}/tarea`, tarea);
  }

  put(id: string, tarea: TareaModel): Observable<any> {
    return this.http.put(`${this.env.URL_API}/tarea/${id}`, tarea);
  }

  get(): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tarea`);
  }

  getById(id: string): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tarea/${id}`);
  }

  getByTipoCaso(tipo_caso: string): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tareaByType/${tipo_caso}`);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.env.URL_API}/tarea/${id}`);
  }

  ultimosdieztareaseditados(): Observable<any> {
    return this.http.post(`${this.env.URL_API}/tarea/ultimosdieztareaseditados`, {});
  }

}
